<!-- <p>asset-history works!</p>-->
<app-dialog-header *ngIf="asset" headerIcon="history"
    headerText="{{asset.Name}} - {{asset.Description}} Event & Action History"
    (onCloseClick)="onCancelClick()"></app-dialog-header>

<div class="main-history-div">
    <div [ngTemplateOutlet]="overviewBanner"></div>
    <ejs-tab id="element" headerPlacement="Top" [selectedItem]="selectedTab" (selected)="updateSelectedTab($event)">
        <e-tabitems>
            @if (assetHistory) {
            @if (checkFeature(AccountFeatures.SAP)) {
            @if (assetHistory.CMMSCaseHistory.length > 0){
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--sapCases">
                        <mat-icon />&nbsp;CMMS Case History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container *ngIf="assetHistory" [ngTemplateOutlet]="CMMSCases"></ng-container>
                </ng-template>
            </e-tabitem>
            } }

            @if (assetHistory.RuleEventHistory.length > 0){
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--notifications">
                        <mat-icon />&nbsp;Rule Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container [ngTemplateOutlet]="ruleEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            }
            @if (assetHistory.SensorEventHistory.length > 0){
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--offline " style="color: inherit;">
                        <mat-icon>sensors_off</mat-icon>&nbsp;Sensor Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container [ngTemplateOutlet]="sensorEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            }
            @if (assetHistory.DeviationEventHistory.length > 0){
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--models">
                        <mat-icon />&nbsp;Deviation Event History
                    </span>
                </ng-template>
                <ng-template #content>
                    <!-- *ngIf="assetHistory" -->
                    <ng-container [ngTemplateOutlet]="deviationEvents"></ng-container>
                </ng-template>
            </e-tabitem>
            }
            @if (checkFeature(AccountFeatures.Actions)) {
            @if (assetHistory.ActionHistory.length > 0){
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--actions">
                        <mat-icon />&nbsp;Action History
                    </span>
                </ng-template>
                <ng-template #content>
                    <ng-container [ngTemplateOutlet]="actions"></ng-container>
                </ng-template>
            </e-tabitem>
            }}
            }
        </e-tabitems>
    </ejs-tab>
</div>
<ng-template #overview>
    <div class="overview-div" *ngIf="assetHistory" [ngStyle]="{'grid-template-columns': getColumnDefinition()}">
        @if (assetHistory.RuleEventHistory.length > 0) {
        <div class="overview-section">
            <span class="overview-section-title">Rule Events</span>
            <button mat-raised-button color="primary" class="app-icon--goto" (click)="changeTab(1)">
                <span>History</span>
                <mat-icon />
            </button>
            <span>Total Events:</span>
            <span><b>{{assetHistory.RuleEventHistory.length}}</b></span>
            <span>Most Recent Event:</span>
            <span><b>{{convertEpoch(assetHistory.RuleEventHistory[0].TimeStamp)}}</b></span>
            <span>Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.RuleEventHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.SensorEventHistory.length > 0) {
        <div class="overview-section">
            <span class="overview-section-title">Sensor Events</span>
            <button mat-raised-button color="primary" class="app-icon--goto"
                (click)="changeTab(2)"><span>History</span><mat-icon /></button>
            <span>Total Events:</span>
            <span><b>{{assetHistory.SensorEventHistory.length}}</b></span>
            <span>Most Recent Event:</span>
            <span><b>{{convertEpoch(assetHistory.SensorEventHistory[0].TimeStamp)}}</b></span>
            <span>Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.SensorEventHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.ActionHistory.length > 0) {
        <div class="overview-section">
            <span class="overview-section-title">Actions</span>
            <button mat-raised-button color="primary" class="app-icon--goto"
                (click)="changeTab(3)"><span>History</span><mat-icon /></button>
            <span>Total Actions:</span>
            <span><b>{{assetHistory.ActionHistory.length}}</b></span>
            <span>Most Recent Action:</span>
            <span><b>{{convertEpoch(assetHistory.ActionHistory[0].Timestamp)}}</b></span>
            <span>Actions In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.ActionHistory.length}}</b></span>
        </div>
        }
        @if (numberOfColumns != 0) {
        <div>
            <span>This Asset '{{asset.Name}}' has no event history.</span>
        </div>
        }
    </div>
</ng-template>

<ng-template #overviewBanner>
    @if (assetHistory) {
    @if (numberOfColumns == 0) {
    <div class="banner-div">
        <span>This Asset '{{asset.Name}}' has no event history.</span>
    </div>
    } @else {
    <div class="banner-div" [ngStyle]="{'grid-template-columns': getColumnDefinition(), 'height': getBannerHeight()}">
        @if (assetHistory.CMMSCaseHistory.length > 0){
        <div class="banner-column">
            <span>Total CMMS Cases:</span>
            <span><b>{{assetHistory.CMMSCaseHistory.length}}</b></span>
            <span>Most Recent CMMS Case:</span>
            <span><b>{{convertEpoch(assetHistory.CMMSCaseHistory[0].CMMSCreatedAt)}}</b></span>
            <span>CMMS Cases In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.CMMSCaseHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.RuleEventHistory.length > 0){
        <div class="banner-column">
            <span>Total Rule Events:</span>
            <span><b>{{assetHistory.RuleEventHistory.length}}</b></span>
            <span>Most Recent Rule Event:</span>
            <span><b>{{convertEpoch(assetHistory.RuleEventHistory[0].TimeStamp)}}</b></span>
            <span>Rule Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.RuleEventHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.SensorEventHistory.length > 0){
        <div class="banner-column">
            <span>Total Sensor Events:</span>
            <span><b>{{assetHistory.SensorEventHistory.length}}</b></span>
            <span>Most Recent Sensor Event:</span>
            <span><b>{{convertEpoch(assetHistory.SensorEventHistory[0].TimeStamp)}}</b></span>
            <span>Sensor Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.SensorEventHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.ActionHistory.length > 0){
        <div class="banner-column">
            <span>Total Actions:</span>
            <span><b>{{assetHistory.ActionHistory.length}}</b></span>
            <span>Most Recent Action:</span>
            <span><b>{{convertEpoch(assetHistory.ActionHistory[0].Timestamp)}}</b></span>
            <span>Actions In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.ActionHistory.length}}</b></span>
        </div>
        }
        @if (assetHistory.DeviationEventHistory.length > 0){
        <div class="banner-column">
            <span>Total Deviation Events:</span>
            <span><b>{{assetHistory.DeviationEventHistory.length}}</b></span>
            <span>Most Recent Deviation Event:</span>
            <span><b>{{convertEpoch(assetHistory.DeviationEventHistory[0].Timestamp)}}</b></span>
            <span>Deviation Events In Past 30 Days:</span>
            <span><b>{{assetHistoryThirtyDays.DeviationEventHistory.length}}</b></span>
        </div>
        }
    </div>
    }
    }
</ng-template>

<ng-template #CMMSCases>
    <div class="cmms-case-item">
        <span>Trigger</span>
        <span>Description</span>
        <span>Opened</span>
        <span>Closed</span>
    </div>
    @if (assetHistory.CMMSCaseHistory) {
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.CMMSCaseHistory' [fields]="fields5" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="rule-event-item ejs-listbox-item">
                    <span>{{data.Trigger}}</span>
                    <span>{{data.Description}}</span>
                    <span>{{convertEpoch(data.OpenedAt)}}</span>
                    <span>
                        @if (data.ClosedAt > 0){
                        {{convertEpoch(data.ClosedAt)}}
                        }@else{&nbsp;}</span>
                    <span class="app-icon app-icon--goto" (click)="goToItem(5, data.Id)"
                        matTooltip="View Case"><mat-icon /></span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
    }
</ng-template>

<ng-template #ruleEvents>
    <div class="rule-event-item">
        <span>Rule Name</span>
        <span>Conditions</span>
        <span>Values</span>
        <span>Timestamp</span>
    </div>
    @if (assetHistory && assetHistory.RuleEventHistory) {
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.RuleEventHistory' [fields]="fields" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="rule-event-item ejs-listbox-item">
                    <span>{{data.RuleName}}</span>
                    <span>{{data.RuleText}}</span>
                    <span>{{data.RuleValues}}</span>
                    <span>{{convertEpoch(data.TimeStamp)}}</span>
                    <span class="app-icon app-icon--goto" (click)="goToItem(1, data.RuleEventID)"
                        matTooltip="View Event"><mat-icon /></span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
    }
</ng-template>

<ng-template #sensorEvents>
    <div class="sensor-event-item">
        <span>Sensor Name</span>
        <span>Event Type</span>
        <span>Timestamp</span>
    </div>
    @if (assetHistory && assetHistory.SensorEventHistory) {
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.SensorEventHistory' [fields]="fields2" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="sensor-event-item ejs-listbox-item">
                    <span>{{data.SensorName}}</span>
                    <!-- <span>{{data.SensorEventType}}</span> -->
                    <span>Sensor Offline</span>
                    <span>{{convertEpoch(data.TimeStamp)}}</span>
                    <span class="app-icon app-icon--goto" (click)="goToItem(2, data.SensorEventID)"
                        matTooltip="View Event"><mat-icon /></span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
    }
</ng-template>

<ng-template #actions>
    <nav class="filterDiv">
        <span class="toolbar-spacer"></span>
        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='actionTypesFilter' [value]="actionTypesFilterID"
            [fields]="actionTypesFields" (change)="filterActions($event)">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.description }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
    </nav>
    <div class="action-item">
        <span>Action Type</span>
        <span>Details</span>
        <span>Target Completion Date</span>
        <span>Created By</span>
        <span>Created On</span>
        <span>Assigned To</span>
        <span>Completed</span>
        <span>Completed On</span>
    </div>
    @if (assetHistory && assetHistory.ActionHistory) {
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.ActionHistory' [fields]="fields3" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="action-item ejs-listbox-item">
                    <span>{{getActionTypeFromValue(data.ActionType)}}</span>
                    <span>{{data.Details}}</span>
                    <span>{{convertEpoch(data.TargetCompletionTimestamp)}}</span>
                    <span>{{data.CreatedByUserSub}}</span>
                    <span>{{convertEpoch(data.Timestamp)}}</span>
                    <span>{{data.AssignedToUserName}}</span>
                    <span>{{data.Completed ? "Yes":"No"}}</span>
                    <span>{{data.Completed ? convertEpoch(data.CompletedTimestamp):""}}</span>
                    <span class="app-icon app-icon--goto" (click)="goToItem(3, data.ActionID)"
                        matTooltip="View Event"><mat-icon /></span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
    }
</ng-template>

<ng-template #deviationEvents>
    <div class="deviation-event-item">
        <span>Model Type</span>
        <span>Z-Score</span>
        <span>Tolerance</span>
        <span>Sensitivity</span>
        <span>Timestamp</span>
    </div>
    @if (assetHistory && assetHistory.DeviationEventHistory) {
    <div class="rule-events-box">
        <ejs-listbox [dataSource]='assetHistory.DeviationEventHistory' [fields]="fields4" class="listbox-container">
            <ng-template #itemTemplate let-data>
                <div class="deviation-event-item ejs-listbox-item">
                    <span>{{getModelTypeName(data.ModelType)}}</span>
                    <span>{{data.ZScore}}</span>
                    <span>{{data.AcceptableDeviation}}</span>
                    <span>{{data.Sensitivity}}</span>
                    <span>{{convertEpoch(data.Timestamp)}}</span>
                    <span class="app-icon app-icon--goto" (click)="goToItem(4, data.RuleEventID)"
                        matTooltip="View Event"><mat-icon /></span>
                </div>
            </ng-template>
        </ejs-listbox>
    </div>
    }
</ng-template>